/*
export const someGetter = (state) => {
}
*/

export const getRole = (state) => {
  return state.role
}

export const isAuth = (state) => {
  return state.token !== null
}

export const isAdmin = (state) => {
  return state.userdata !== null && state.userdata.webrole !== null && state.userdata.webrole === 'admin'
}

export const getEmailAddressOrEmptyString = (state) => {
  if (state.userdata === null || state.userdata === '') {
    return ''
  } else {
    return state.userdata.email
  }
}
